import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import * as XLSX from 'xlsx';
import {
  Row, Col, Card, Table, Button, Input,
  notification, Modal, Select, Typography,
  Checkbox, DatePicker, Drawer, Form, Tooltip, Avatar, Image, Space, Tag, Spin
} from "antd";
import axios from "axios";
import { baseUrl } from "../../config";
import {
  DeleteOutlined, FileExcelOutlined,
  FilterOutlined, EditOutlined, ExclamationCircleOutlined, PlusOutlined, UserOutlined,
  PhoneOutlined, CalendarOutlined, ReloadOutlined, CloseOutlined, SearchOutlined,
  TrophyOutlined, BookOutlined
} from "@ant-design/icons";
import userDummy from "../../assets/images/dummy-user.png";
import { getPermissions, hasPermission } from '../../components/permissions';
import '../../assets/styles/custom_style.css';
import moment from 'moment';
import CompExamResultsForm from './Form';
// import ImportListModal from './components/importListModal';

const { confirm } = Modal;
const { Option } = Select;
const { Title, Text } = Typography;

function CompExamResults() {
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const currentPageQuery = parseInt(queryParams.get('page')) || 1;
  const limitQuery = parseInt(queryParams.get('limit')) || 20;

  const [compExamResultsList, setCompExamResultsList] = useState([]);
  const [pagination, setPagination] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(limitQuery);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  
  const [filters, setFilters] = useState({
    student_name: queryParams.get('student_name') || '',
    father_name: queryParams.get('father_name') || '',
    gender: queryParams.get('gender') || '',
    mobile_no_1: queryParams.get('mobile_no_1') || '',
    village: queryParams.get('village') || '',
    tehsil: queryParams.get('tehsil') || '',
    district: queryParams.get('district') || '',
    selected_post: queryParams.get('selected_post') || '',
    present_post: queryParams.get('present_post') || '',
    preparation_category: queryParams.get('preparation_category') || '',
    batch: queryParams.get('batch') || '',
    dob: queryParams.get('dob') || '',
    joining_date: queryParams.get('joining_date') || '',
    createdAt: queryParams.get('createdAt') || '',
  });

  // Drawer states
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [isUpdateMode, setIsUpdateMode] = useState(false);

  // Filter and modal states
  const [showCompExamFilter, setShowCompExamFilter] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisibleImportList, setIsModalVisibleImportList] = useState(false);
  const [currentImage, setCurrentImage] = useState("");

  // Enhanced table columns with better styling
  const columns = [
    {
      title: <Text strong style={{ color: '#7a0000' }}>#</Text>,
      dataIndex: "key",
      key: "key",
      fixed: 'left',
      width: 60,
      align: 'center',
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Photo</Text>,
      dataIndex: "photo",
      key: "photo",
      fixed: 'left',
      width: 80,
      align: 'center',
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Student Name</Text>,
      dataIndex: "student_name",
      key: "student_name",
      fixed: 'left',
      width: 150,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Father Name</Text>,
      dataIndex: 'father_name',
      key: 'father_name',
      width: 150,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Gender</Text>,
      dataIndex: 'gender',
      key: 'gender',
      width: 80,
      align: 'center',
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>DOB</Text>,
      dataIndex: "dob",
      key: "dob",
      width: 120,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Village</Text>,
      dataIndex: "village",
      key: "village",
      width: 120,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Tehsil</Text>,
      dataIndex: "tehsil",
      key: "tehsil",
      width: 120,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>District</Text>,
      dataIndex: "district",
      key: "district",
      width: 120,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Mobile 1</Text>,
      dataIndex: "mobile_no_1",
      key: "mobile_no_1",
      width: 130,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Mobile 2</Text>,
      dataIndex: "mobile_no_2",
      key: "mobile_no_2",
      width: 130,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Selected Post</Text>,
      dataIndex: "selected_post",
      key: "selected_post",
      width: 180,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Joining Date</Text>,
      dataIndex: "joining_date",
      key: "joining_date",
      width: 120,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Present Post</Text>,
      dataIndex: "present_post",
      key: "present_post",
      width: 150,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Present Address</Text>,
      dataIndex: "present_address",
      key: "present_address",
      width: 180,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Preparation Category</Text>,
      dataIndex: "preparation_category",
      key: "preparation_category",
      width: 200,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Duration</Text>,
      dataIndex: "duration",
      key: "duration",
      width: 120,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Batch</Text>,
      dataIndex: "batch",
      key: "batch",
      width: 120,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Entry Date</Text>,
      dataIndex: "createdAt",
      key: "createdAt",
      width: 120,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Actions</Text>,
      key: "action",
      dataIndex: "action",
      fixed: 'right',
      width: 120,
      align: 'center',
    }
  ];

  useEffect(() => {
    const { state } = history.location;
    const restoredPage = state?.page || currentPage;
    const restoredLimit = state?.limit || limit;
    getCompExamResultsList(restoredPage, restoredLimit, sortField, sortOrder, search, filters);
  }, [history.location]);

  // Drawer functions
  const showDrawer = (userId = null) => {
    setCurrentUserId(userId);
    setIsUpdateMode(!!userId);
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
    setCurrentUserId(null);
    setIsUpdateMode(false);
  };

  const onRefresh = () => {
    closeDrawer();
    getCompExamResultsList(currentPage, limit, sortField, sortOrder, search, filters);
  };

  async function getCompExamResultsList(page = 1, limit = 20, sortField = null, sortOrder = null, search = '', filters = {}) {
    try {
      setLoading(true);
      setCurrentPage(page);
      setLimit(limit);
      const sortParam = sortField && sortOrder ? `&sortField=${sortField}&sortOrder=${sortOrder}` : '';
      const searchParam = search ? `&search=${search}` : '';
      const filterParams = Object.keys(filters)
        .map(key => `${key}=${filters[key]}`)
        .join('&');
      const response = await axios.get(`${baseUrl}/comp_exam_results/list?page=${page}&limit=${limit}${sortParam}${searchParam}&${filterParams}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
      });
      if (response.data.status) {
        setCompExamResultsList(response.data.result);
        setPagination({
          current: page,
          pageSize: limit,
          total: response.data.totalCount
        });
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to fetch Competition Exam Results data',
        placement: 'topRight'
      });
    } finally {
      setLoading(false);
    }
  }

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`${baseUrl}/comp_exam_results/delete/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      if (response.status === 200) {
        getCompExamResultsList(pagination.current, pagination.pageSize, sortField, sortOrder, search, filters);
        notification.success({
          message: 'Success',
          description: 'Competition Exam Result deleted successfully!',
          placement: 'topRight'
        });
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to delete Competition Exam Result',
        placement: 'topRight'
      });
    }
  };

  const showDeleteConfirm = (id, studentName) => {
    confirm({
      title: 'Delete Competition Exam Result',
      icon: <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />,
      content: (
        <div>
          <p>Are you sure you want to delete this Competition Exam Result?</p>
          {studentName && (
            <div style={{ 
              background: '#fff2f0', 
              border: '1px solid #ffccc7', 
              padding: '8px 12px', 
              borderRadius: '6px',
              marginTop: '8px'
            }}>
              <Text strong style={{ color: '#cf1322' }}>Student to be deleted:</Text>
              <br />
              <Text>{studentName}</Text>
            </div>
          )}
          <p style={{ color: '#8c8c8c', fontSize: '12px', marginTop: '8px' }}>
            ⚠️ This action cannot be undone.
          </p>
        </div>
      ),
      okText: 'Yes, Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      okButtonProps: {
        danger: true,
        style: { borderRadius: '6px' }
      },
      cancelButtonProps: {
        style: { borderRadius: '6px' }
      },
      onOk() {
        handleDelete(id);
      },
    });
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const { current, pageSize } = pagination;
    const { field, order } = sorter;
    const formattedOrder = order === 'ascend' ? 'asc' : 'desc';
    setSortField(field);
    setSortOrder(formattedOrder);
    setFilters(filters);
    history.push(`?page=${current}&limit=${pageSize}`);
    getCompExamResultsList(current, pageSize, field, formattedOrder, search, filters);
  };

  const handleLimitChange = value => {
    setLimit(value);
    const updatedQueryParams = new URLSearchParams(location.search);
    updatedQueryParams.set('limit', value);
    updatedQueryParams.set('page', 1);
    history.push(`?${updatedQueryParams.toString()}`);
    getCompExamResultsList(1, value);
  };

  const handleFilterChange = (field, value) => {
    const newFilters = {
      ...filters,
      [field]: value
    };
    setFilters(newFilters);
    const updatedQueryParams = new URLSearchParams(location.search);
    Object.keys(newFilters).forEach(key => {
      if (newFilters[key]) {
        updatedQueryParams.set(key, newFilters[key]);
      } else {
        updatedQueryParams.delete(key);
      }
    });
    history.push(`?${updatedQueryParams.toString()}`);
  };

  const handleSearch = () => {
    getCompExamResultsList(1, limit, sortField, sortOrder, search, filters);
  };

  const handleResetFilters = () => {
    const resetFilters = {
      student_name: '',
      father_name: '',
      gender: '',
      mobile_no_1: '',
      village: '',
      tehsil: '',
      district: '',
      selected_post: '',
      present_post: '',
      preparation_category: '',
      batch: '',
      dob: '',
      joining_date: '',
      createdAt: '',
    };
    setFilters(resetFilters);
    setSearch('');
    const updatedQueryParams = new URLSearchParams(location.search);
    Object.keys(resetFilters).forEach(key => {
      updatedQueryParams.delete(key);
    });
    history.push(`?${updatedQueryParams.toString()}`);
    getCompExamResultsList(1, limit, sortField, sortOrder, '', resetFilters);
  };

  const exportToExcel = async () => {
    try {
      setLoading(true);
      const sortParam = sortField && sortOrder ? `&sortField=${sortField}&sortOrder=${sortOrder}` : '';
      const searchParam = search ? `&search=${search}` : '';
      const filterParams = Object.keys(filters)
        .map(key => `${key}=${filters[key]}`)
        .join('&');
      const response = await axios.get(`${baseUrl}/comp_exam_results/list?page=${1}&limit=all${sortParam}${searchParam}&${filterParams}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
      });
      if (response.data.status) {
        const formattedData = response.data.result.map((student, index) => ({
          "Sr.No": index + 1,
          "Student Name": student.student_name,
          "Father Name": student.father_name,
          "Gender": student.gender,
          "DOB": student.dob ? moment(student.dob).format('DD-MM-YYYY') : '-',
          "Village": student.village,
          "Tehsil": student.tehsil,
          "District": student.district,
          "Mobile 1": student.mobile_no_1,
          "Mobile 2": student.mobile_no_2,
          "Selected Post": student.selected_post,
          "Joining Date": student.joining_date ? moment(student.joining_date).format('DD-MM-YYYY') : '-',
          "Present Post": student.present_post,
          "Present Address": student.present_address,
          "Preparation Category": student.preparation_category,
          "Duration (Months)": student.duration_months,
          "Duration (Years)": student.duration_years,
          "Batch": student.batch,
          "Other Details": student.other_details,
          "Remarks": student.remarks,
          "Entry Date": student.createdAt ? moment(student.createdAt).format('DD-MM-YYYY') : '-',
        }));

        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Competition-Exam-Results");
        XLSX.writeFile(workbook, "Competition-Exam-Results.xlsx");
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to export data',
        placement: 'topRight'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tabled">
      <Row gutter={[24, 0]}>
        <Col xs="24" xl={24}>
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            headStyle={{ background: '#f8fafc', borderBottom: '1.5px solid #e2e8f0' }}
            title={
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <TrophyOutlined style={{ color: '#fff', fontSize: '20px' }} />
                <Title level={3} style={{ margin: 0, color: '#fff' }}>
                  Competition Exam Results
                </Title>
              </div>
            }
            extra={
              <Space size="middle">
                <Button
                  type="default"
                  icon={<FileExcelOutlined />}
                  onClick={() => setIsModalVisibleImportList(true)}
                  style={{ borderRadius: '6px' }}
                >
                  Import List
                </Button>
                {hasPermission('/comp-exam-results', 'createPermission') && (
                  <Button
                    onClick={() => showDrawer()}
                    style={{
                      background: '#fff',
                      color: '#7a0000',
                      borderColor: '#fff',
                      borderRadius: '6px',
                      fontWeight: 600,
                      boxShadow: '0 2px 4px rgba(0,0,0,0.15)'
                    }}
                  >
                    Add Exam Result
                  </Button>
               )}
                {hasPermission('/comp-exam-results', 'downloadPermission') && (
                  <Button
                    type="default"
                    icon={<FileExcelOutlined />}
                    onClick={exportToExcel}
                    style={{ borderRadius: '6px' }}
                  >
                    Export Excel
                  </Button>
                )}
              </Space>
            }
          >
            <div className="table-responsive">
              <Table
                columns={columns}
                loading={loading}
                scroll={{ x: 'max-content' }}
                bordered
                size="middle"
                title={() => (
                  <div style={{ marginBottom: '16px' }}>
                    <Row gutter={[16, 16]} align="middle">
                      <Col>
                        <Button
                          icon={<FilterOutlined />}
                          onClick={() => setShowCompExamFilter(!showCompExamFilter)}
                          style={{
                            borderRadius: '6px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                          }}
                        >
                          {showCompExamFilter ? 'Hide Filters' : 'Show Filters'}
                        </Button>
                      </Col>
                    </Row>

                    {/* Filters */}
                    {showCompExamFilter && (
                      <div style={{
                        marginTop: '16px',
                        padding: '16px',
                        background: '#f8f9fa',
                        borderRadius: '8px',
                        border: '1px solid #e9ecef'
                      }}>
                        <Row gutter={[12, 12]}>
                          <Col span={6}>
                            <Input
                              placeholder="Search by student name"
                              value={filters.student_name}
                              onChange={e => handleFilterChange('student_name', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Father name"
                              value={filters.father_name}
                              onChange={e => handleFilterChange('father_name', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Select
                              placeholder="Gender"
                              value={filters.gender}
                              onChange={value => handleFilterChange('gender', value)}
                              style={{ width: '100%', borderRadius: '6px' }}
                              allowClear
                            >
                              <Option value="">All Gender</Option>
                              <Option value="Male">Male</Option>
                              <Option value="Female">Female</Option>
                            </Select>
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Mobile number"
                              value={filters.mobile_no_1}
                              onChange={e => handleFilterChange('mobile_no_1', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Village"
                              value={filters.village}
                              onChange={e => handleFilterChange('village', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Tehsil"
                              value={filters.tehsil}
                              onChange={e => handleFilterChange('tehsil', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="District"
                              value={filters.district}
                              onChange={e => handleFilterChange('district', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Selected post"
                              value={filters.selected_post}
                              onChange={e => handleFilterChange('selected_post', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Present post"
                              value={filters.present_post}
                              onChange={e => handleFilterChange('present_post', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Select
                              placeholder="Preparation Category"
                              value={filters.preparation_category}
                              onChange={value => handleFilterChange('preparation_category', value)}
                              style={{ width: '100%', borderRadius: '6px' }}
                              allowClear
                            >
                              <Option value="">All Categories</Option>
                              <Option value="Shri Kheteshwar Pratiyogi Pariksha Kendra, Badli">
                                Shri Kheteshwar Pratiyogi Pariksha Kendra, Badli
                              </Option>
                              <Option value="Financial Help - External Preparation">
                                Financial Help - External Preparation
                              </Option>
                              <Option value="Coaching Classes Only">
                                Coaching Classes Only
                              </Option>
                              <Option value="Library Facility Only">
                                Library Facility Only
                              </Option>
                              <Option value="Other Support">
                                Other Support
                              </Option>
                            </Select>
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Batch"
                              value={filters.batch}
                              onChange={e => handleFilterChange('batch', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <DatePicker
                              className="filter_dob"
                              format="DD-MM-YYYY"
                              value={filters.dob ? moment(filters.dob, 'DD-MM-YYYY') : null}
                              onChange={(date, dateString) => handleFilterChange('dob', dateString)}
                              placeholder="DOB Date"
                              style={{ width: '100%', borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <DatePicker
                              className="filter_dob"
                              format="DD-MM-YYYY"
                              value={filters.joining_date ? moment(filters.joining_date, 'DD-MM-YYYY') : null}
                              onChange={(date, dateString) => handleFilterChange('joining_date', dateString)}
                              placeholder="Joining Date"
                              style={{ width: '100%', borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <DatePicker
                              className="filter_dob"
                              format="DD-MM-YYYY"
                              value={filters.createdAt ? moment(filters.createdAt, 'DD-MM-YYYY') : null}
                              onChange={(date, dateString) => handleFilterChange('createdAt', dateString)}
                              placeholder="Entry Date"
                              style={{ width: '100%', borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={24}>
                            <Space>
                              <Button
                                icon={<SearchOutlined />}
                                onClick={handleSearch}
                                style={{ borderRadius: '6px', background: '#7a0000', borderColor: '#7a0000', color: '#fff' }}
                              >
                                Search
                              </Button>
                              <Button
                                icon={<ReloadOutlined />}
                                onClick={handleResetFilters}
                                style={{ borderRadius: '6px' }}
                              >
                                Reset All Filters
                              </Button>
                            </Space>
                          </Col>
                        </Row>
                      </div>
                    )}

                    <Row style={{ marginTop: '16px' }}>
                      <Col>
                        <Space align="center">
                          <Text strong>Records per page:</Text>
                          <Select
                            value={limit}
                            onChange={handleLimitChange}
                            style={{ width: 80, borderRadius: '6px' }}
                          >
                            <Option value={20}>20</Option>
                            <Option value={40}>40</Option>
                            <Option value={60}>60</Option>
                            <Option value={80}>80</Option>
                            <Option value={100}>100</Option>
                            <Option value={250}>250</Option>
                            {/* <Option value={300}>300</Option> */}
                          </Select>
                        </Space>
                      </Col>
                    </Row>
                  </div>
                )}
                dataSource={compExamResultsList.map((student, index) => {
                  const durationText = [];
                  if (student.duration_years) durationText.push(`${student.duration_years} Yr`);
                  if (student.duration_months) durationText.push(`${student.duration_months} Mo`);
                  
                  return {
                    key: (limit * (currentPage - 1)) + index + 1,
                    photo: (
                      <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Image
                          width={50}
                          height={50}
                          className="shape-avatar"
                          src={student.student_photo ? student.student_photo : userDummy}
                          style={{ 
                            borderRadius: '8px',
                            objectFit: 'cover',
                            border: '2px solid #f0f0f0'
                          }}
                          fallback={userDummy}
                        />
                      </div>
                    ),
                    student_name: (
                      <Text strong style={{ color: '#262626' }}>{student.student_name}</Text>
                    ),
                    father_name: (
                      <Text style={{ color: '#595959' }}>{student.father_name || '-'}</Text>
                    ),
                    gender: (
                      <div style={{ textAlign: 'center' }}>
                        <Tag color={student.gender === 'Male' ? 'blue' : 'pink'} style={{ borderRadius: '12px', fontWeight: '500' }}>
                          {student.gender || '-'}
                        </Tag>
                      </div>
                    ),
                    dob: (
                      <Text>{student.dob ? moment(student.dob).format('DD MMM YYYY') : '-'}</Text>
                    ),
                    village: (
                      <Text style={{ color: '#595959' }}>{student.village || '-'}</Text>
                    ),
                    tehsil: (
                      <Text style={{ color: '#595959' }}>{student.tehsil || '-'}</Text>
                    ),
                    district: (
                      <Text style={{ color: '#595959' }}>{student.district || '-'}</Text>
                    ),
                    mobile_no_1: (
                      <Text strong style={{ color: '#7a0000' }}>{student.mobile_no_1 || '-'}</Text>
                    ),
                    mobile_no_2: (
                      <Text style={{ color: '#595959' }}>{student.mobile_no_2 || '-'}</Text>
                    ),
                    selected_post: (
                      <Text strong style={{ color: '#52c41a' }}>{student.selected_post || '-'}</Text>
                    ),
                    joining_date: (
                      <Text>
                        {student.joining_date && student.joining_date !== "0000-00-00" 
                          ? moment(student.joining_date).format('DD MMM YYYY') 
                          : '-'}
                      </Text>
                    ),
                    present_post: (
                      <Text style={{ color: '#595959' }}>{student.present_post || '-'}</Text>
                    ),
                    present_address: (
                      <Text style={{ color: '#595959' }}>{student.present_address || '-'}</Text>
                    ),
                    preparation_category: (
                      <div>
                        <Tag color="processing" style={{ borderRadius: '12px', fontSize: '11px' }}>
                          {student.preparation_category || 'Not Specified'}
                        </Tag>
                      </div>
                    ),
                    duration: (
                      <Text style={{ color: '#595959' }}>
                        {durationText.length > 0 ? durationText.join(', ') : '-'}
                      </Text>
                    ),
                    batch: (
                      <div style={{ textAlign: 'center' }}>
                        <Tag color="gold" style={{ borderRadius: '12px', fontWeight: '500' }}>
                          {student.batch || '-'}
                        </Tag>
                      </div>
                    ),
                    createdAt: (
                      <Text>
                        {student.createdAt && student.createdAt !== "0000-00-00" 
                          ? moment(student.createdAt).format('DD MMM YYYY') 
                          : '-'}
                      </Text>
                    ),
                    action: (
                      <Space size="small">
                        {hasPermission('/comp-exam-results', 'editPermission') && (
                          <Button
                            size="small"
                            icon={<EditOutlined />}
                            onClick={() => showDrawer(student.id)}
                            style={{ borderRadius: '4px', background: '#7a0000', borderColor: '#7a0000', color: '#fff' }}
                          >
                            Edit
                          </Button>
                        )}
                        {hasPermission('/comp-exam-results', 'deletePermission') && (
                          <Button
                            danger
                            size="small"
                            icon={<DeleteOutlined />}
                            onClick={() => showDeleteConfirm(student.id, student.student_name)}
                            style={{ borderRadius: '4px' }}
                          >
                            Delete
                          </Button>
                        )}
                      </Space>
                    )
                  };
                })}
                pagination={{
                  ...pagination,
                  showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} records`,
                  showSizeChanger: false,
                  style: { marginTop: '16px' }
                }}
                onChange={handleTableChange}
                className="ant-border-space"
                style={{
                  borderRadius: '8px',
                  overflow: 'hidden'
                }}
              />
            </div>
          </Card>
        </Col>
      </Row>

      {/* Enhanced Drawer for Add/Edit */}
      <Drawer
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              background: 'rgba(255,255,255,0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              {isUpdateMode ? <EditOutlined style={{ color: 'white', fontSize: '18px' }} /> : <TrophyOutlined style={{ color: 'white', fontSize: '18px' }} />}
            </div>
            <div>
              <Title level={4} style={{ margin: 0, color: 'white' }}>
                {isUpdateMode ? 'Update Exam Result' : 'Add New Exam Result'}
              </Title>
          
            </div>
          </div>
        }
        width={window.innerWidth > 768 ? 700 : '95%'}
        open={drawerVisible}
        onClose={closeDrawer}
        closable={false}
        bodyStyle={{
          padding: 0,
          background: '#f8f9fa'
        }}
        headerStyle={{
          background: '#7a0000',
          border: 'none'
        }}
        extra={
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={closeDrawer}
            style={{ color: 'white' }}
          />
        }
        destroyOnClose
      >
        <div style={{ height: '100%', padding: '24px' }}>
          <CompExamResultsForm 
            userId={currentUserId} 
            onRefreshData={onRefresh}
          />
        </div>
      </Drawer>


      {/* Image Modal */}
      <Modal
        open={isModalVisible}
        footer={null}
        onCancel={() => setIsModalVisible(false)}
        centered
      >
        <img
          src={currentImage}
          alt="Student Photo"
          style={{ width: '100%', borderRadius: '8px' }}
        />
      </Modal>
    </div>
  );
}

export default CompExamResults;